import { APP } from 'pricing-pages-ui/constants/tracking/App';
import { productBasedOfferIdsWithMandatorySkuSelector } from 'pricing-pages-ui/selectors/ProductBasedOffersSelectors';
import { checkoutProductConfigurationsSelector, productVersionConfigsWithUnitsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { getBundleTypeInProductInventorySelector, hasHigherProductLevelInProductInventorySelector, hasProductVersionInBundledProductInventorySelector, hasProductVersionInProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { purchaseMotionsSelector } from 'pricing-pages-ui/selectors/PurchaseMotionSelectors';
import { useSelector } from 'react-redux';
import { SCREENS } from '../../constants/tracking/Screens';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
const buttonUses = {
  primaryButtonUse: 'primary',
  secondaryButtonUse: 'secondary'
};

// Common props that are used for recommended Sales Hub Pro AuthedCTAs, and the loading state buttons
export const useRecommendedSalesHubProCTAsProps = ({
  additionalUnitQuantity,
  additionalUnitSkuId,
  skuId,
  trackingSource,
  purchaseMotions
}) => {
  const {
    productLevel,
    productLine
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }) || {});
  const apiName = useSelector(state => {
    const product = productForSkuIdSelector(state, {
      skuId
    });
    return product && product.apiName;
  });
  const fallbackPurchaseMotions = useSelector(state => purchaseMotionsSelector(state, {
    skuId
  }));
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.RECOMMENDED,
    uniqueId: `${trackingSource}-${upgradeProduct}`,
    upgradeProduct
  };
  const productConfigurations = useSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: productVersionConfigsWithUnitsSelector(state, {
      skuId,
      additionalUnitSkuId,
      additionalUnitQuantity
    }),
    subtractOwnedUnitsIfBuyingNoAdditional: true,
    subtractOwnedSeats: true
  }));
  return Object.assign({
    purchaseMotions: purchaseMotions || fallbackPurchaseMotions,
    upgradeData,
    productBasedOffers: useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
      skuIds: [skuId]
    })),
    currencyCode: useDisplayedCurrencyCode(),
    productConfigurations,
    ownsProduct: useSelector(state => hasProductVersionInProductInventorySelector(state, {
      skuId
    })),
    ownsProductViaBundle: useSelector(state => hasProductVersionInBundledProductInventorySelector(state, {
      skuId
    })),
    bundleType: useSelector(state => getBundleTypeInProductInventorySelector(state, {
      skuId
    })),
    hasHigherTieredProduct: useSelector(state => hasHigherProductLevelInProductInventorySelector(state, {
      productLevel,
      productLine
    })),
    fallbackSeleniumIdentifier: apiName
  }, buttonUses);
};